import React, { useCallback } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import styles from 'styles/jss/original/components/menus/detailImage';
import dummyImage from 'public/img/ui/loading-dummy.gif';
import classNames from 'classnames';
import Img from 'react-image';
import { IMenu } from '@/@types/generated/contentful';

// @ts-expect-error
const useStyles = makeStyles(styles);

type ComponentProps = {
  menu: IMenu;
  isSp: boolean;
};

const DetailImage: React.FC<ComponentProps> = ({ menu, isSp }) => {
  const { title, mainImage, mainImageL } = menu.fields;
  const classes = useStyles();
  const getImageUrl = useCallback(() => {
    if (isSp) {
      return `${mainImageL?.fields.file.url}?fm=webp&fit=pad&w=800`;
    } else {
      return `${mainImage.fields.file.url}?fm=webp`;
    }
  }, [isSp, mainImage.fields.file.url, mainImageL?.fields.file.url]);
  const Load = () => <img src={dummyImage} alt='ローディング中' className={classes.imgLoading} />;

  return (
    <div className={classes.section}>
      <div className={classes.container}>
        <Img
          src={getImageUrl()}
          loader={<Load />}
          className={classNames(classes.img, classes.imgRaised, classes.imgRounded)}
          alt={title}
        />
      </div>
    </div>
  );
};

export default DetailImage;
